import React, { createContext, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

// Usando a biblioteca uuid para gerar IDs únicos e seguros
const generateId = () => uuidv4();

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);
    const [closingAlerts, setClosingAlerts] = useState({});

    const addAlert = (alert) => {
        const id = generateId();
        const newAlert = { ...alert, id };
        setAlerts(prev => [...prev, newAlert]);

        if (alert.autoClose !== false) {
            setTimeout(() => closeAlert(id), alert.duration || 5000);
        }

        return id;
    };

    const closeAlert = (id) => {
        setClosingAlerts(prev => ({ ...prev, [id]: true }));

        setTimeout(() => {
            removeAlert(id);
        }, 300);
    };

    const removeAlert = (id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
        setClosingAlerts(prev => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
        });
    };    // Utilizando useMemo para evitar recriação do objeto do contexto a cada renderização
    const contextValue = useMemo(() => ({
        alerts,
        addAlert,
        closeAlert,
        removeAlert,
        closingAlerts
    }), [alerts, closingAlerts]);

    return (
        <AlertContext.Provider value={contextValue}>
            {children}
        </AlertContext.Provider>
    );
};

AlertProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useAlerts = () => useContext(AlertContext);